import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=8a9a806e&scoped=true"
import script from "./CreateDialog.vue?vue&type=script&lang=ts"
export * from "./CreateDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateDialog.vue?vue&type=style&index=0&id=8a9a806e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9a806e",
  null
  
)

export default component.exports